import React from 'react'
import { useCreateUpsell } from './actions'
import { Button } from 'react-bootstrap'
import PropTypes from 'prop-types'
import useTrackingContext from '../../hooks/useTrackingContext'
import { useUpsellContext } from '../../UpsellContext'

const OrderAllButton = ({
  organisations
}) => {
  const tracker = useTrackingContext()
  const { round } = useUpsellContext()

  const createAllUpsellOrders = useCreateUpsell({
    mutationFn: async(_values) => {
      tracker.trackEvent('CatalogOrder', `Upsell Order All Clicked - Round ${round}`)
      const items = organisations.map((organisation) => {
        return { organisation, selected: true }
      })

      const values = { items }

      return values
    },
    organisations,
  })

  return (
    <Button
      variant='primary'
      onClick={createAllUpsellOrders.mutate}
      disabled={createAllUpsellOrders.isLoading}
    >
      {organisations.length === 1
      ? 'Weiteren Katalog bestellen'
      : `Weitere ${organisations.length} Kataloge bestellen`}
    </Button>
  )
}

OrderAllButton.propTypes = {
  organisations: PropTypes.array.isRequired,
}

export default OrderAllButton
